import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
import Breadcrumbs from "../Common/Breadcrumb";
import EditOutwardModal from "../Common/EditOutwardModal";
import {
  acceptDataEntryOutwardBySalesOffice,
  getUserApi,
  getDataEntryOutwards,
  addPartyOutwards,
  getPartyOutwards,
  updateOutward
} from "api";
import moment from "moment/moment";
import * as Yup from "yup";

const defaultSorted = [{ dataField: "id", order: "asc" }];

class ExpressViewInward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      props: props.location.query || { isEdit: 3, data: null },
      isReturnAndAccept: false,
      isReturn: false,
      isModalOpen: false,
      isEditModalOpen: false,
      editRowData: null,
      deliveryBoyList: [],
      expressInwardOutwards: [],
      totalNoOfPiecesDelivered:0,
      totalNoOfCtsDelivered:0,
      expressPartyOutward:[]
    };
  }

  async componentDidMount() {
    const deliveryBoy = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000006",
    });
    this.setState({
      deliveryBoyList: deliveryBoy.data.users,
    });
    this.loadExpressData();
  }
  loadExpressData = async () => {
    const { data } = this.state.props;
  
    if (data?.id) {
      try {
        const expressInward = await getDataEntryOutwards(String(data?.id));
        const expressPartyOutward = await getPartyOutwards(String(data?.id));
  
        const outwardData = Array.isArray(expressPartyOutward?.data)
          ? expressPartyOutward.data
          : [];
  
        const totalNoOfPieces = outwardData.reduce((sum, record) => sum + (record.noOfPieces || 0), 0);
        const totalNoOfCts = outwardData.reduce((sum, record) => sum + (record.totalWeight || 0), 0);
  
        this.setState({
          expressInwardOutwards: expressInward?.data ?? [],
          totalNoOfPiecesDelivered: totalNoOfPieces,
          totalNoOfCtsDelivered: totalNoOfCts,
          expressPartyOutward: expressPartyOutward?.data,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  handleAccept = async (row) => {
    const payload = {
      outwardId: String(row?.id),
    };
    try {
      const accept = await acceptDataEntryOutwardBySalesOffice(payload);
      if (accept?.success === true) {
        if (this.props.refreshList) {
          this.props.refreshList();
        }
        this.props.history?.goBack?.();
      } else {
        console.warn("Accept API did not return success:", accept.message);
      }
    } catch (error) {
      console.error("Error submitting Accept Full:", error);
    }
  };

  handleEdit = (row) => {
    this.setState({
      isEditModalOpen: true,
      editRowData: row
    });
  };
  
  render() {
    const formatNumber = (num) => {
      if (num == null) return "0";
      return Number.isInteger(num) ? num : Number(num).toFixed(2);
    };
    const columns1 = [
      { dataField: "dateTime", text: "Date & Time", sort: true, 
        formatter: (cell, row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss"),
        footer: "",
       },
      { dataField: "deliveryBoy", text: "Delivery Boy", sort: true, 
        formatter: (cell, row) => row.deliveryBoy.name || "N/A",
        footer: "",
       },
       {
        dataField: "pieces",
        text: "Pieces",
        sort: true,
        formatter: (cell, row) => row.noOfPieces || 0,
        footer: () => {
          const total = (this.state.expressInwardOutwards || [])
            .filter(item => item.isProcessed)
            .reduce((sum, item) => sum + (item.noOfPieces || 0), 0);
          return `Total : ${total}`;
        },
      },
      {
        dataField: "cts.",
        text: "Cts",
        sort: true,
        formatter: (cell, row) => formatNumber(row.totalWeight) || 0,
        footer: () => {
          const total = (this.state.expressInwardOutwards || [])
            .filter(item => item.isProcessed)
            .reduce((sum, item) => sum + (item.totalWeight || 0), 0);
          return `Total : ${formatNumber(total)}`;
        },
      },
      
      { dataField: "remarks", text: "Remarks", formatter: (cell, row) => row.remark || "N/A",footer: "", },
      {
        dataField: "action",
        text: "Action",
        formatter: (cell, row) => {
          if (!row.acceptedAt) {
            return (
              <>
               <button
               className="btn btn-sm btn-primary"
               onClick={() => this.handleEdit(row)}
             >
               Edit
             </button>
              <button
                className="btn btn-sm btn-primary  ms-2" 
                onClick={() => this.handleAccept(row)}
              >
                Accept
              </button>
              
             </>
            );
          } else {
            ""
          }
        },
        footer: ""
      }
    
    ];
    const columns2 = [
      {
        dataField: "dateTime",
        text: "Date & Time",
        sort: true,
        formatter: (cell, row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss"),
        footer: "",
      },
      {
        dataField: "deliveryBoy",
        text: "Delivery Boy",
        sort: true,
        formatter: (cell, row) => row.deliveryBoy.name || "N/A",
        footer: "",
      },
      {
        dataField: "pieces",
        text: "Pieces",
        sort: true,
        formatter: (cell, row) => row.noOfPieces || 0,
        footer: () => {
          const total = (this.state.expressInwardOutwards || [])
            .filter(item => !item.isProcessed)
            .reduce((sum, item) => sum + (item.noOfPieces || 0), 0);
          return `Total : ${total}`;
        },
      },
      {
        dataField: "cts.",
        text: "Cts",
        sort: true,
        formatter: (cell, row) => formatNumber(row.totalWeight) || 0,
        footer: () => {
          const total = (this.state.expressInwardOutwards || [])
            .filter(item => !item.isProcessed)
            .reduce((sum, item) => sum + (item.totalWeight || 0), 0);
          return `Total : ${formatNumber(total)}`;
        },
      },
      {
        dataField: "remarks",
        text: "Remarks",
        formatter: (cell, row) => row.remark || "N/A",
        footer: "",
      },
      {
        dataField: "action",
        text: "Action",
        formatter: (cell, row) => {
          if (!row.acceptedAt) {
            return (
              <button
                className="btn btn-sm btn-primary"
                onClick={() => this.handleAccept(row)}
              >
                Accept
              </button>
            );
          } else {
            return null;
          }
        },
        footer: "",
      },
    ];
    
    const columns3 = [
      {
        dataField: "dateTime",
        text: "Date & Time",
        sort: true,
        formatter: (cell, row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss"),
        footer: "",
      },
      {
        dataField: "deliveryBoy",
        text: "Delivery Boy",
        sort: true,
        formatter: (cell, row) => row.deliveryBoy.name || "N/A",
        footer: "",
      },
      {
        dataField: "pieces",
        text: "Pieces",
        sort: true,
        formatter: (cell, row) => row.noOfPieces || 0,
        footer: () => {
          const total = (this.state.expressPartyOutward || [])
            .reduce((sum, item) => sum + (item.noOfPieces || 0), 0);
          return `Total : ${total}`;
        },
      },
      {
        dataField: "cts.",
        text: "Cts",
        sort: true,
        formatter: (cell, row) => formatNumber(row.totalWeight) || 0,
        footer: () => {
          const total = (this.state.expressPartyOutward || [])
            .reduce((sum, item) => sum + (item.totalWeight || 0), 0);
          return `Total : ${formatNumber(total)}`;
        },
      },
      {
        dataField: "remarks",
        text: "Remarks",
        formatter: (cell, row) => row.remark || "N/A",
        footer: "",
      },
      {
        dataField: "action",
        text: "Action",
        formatter: (cell, row) => "",
        footer: "",
      },
    ];
    
    document.title = "Sales-office";
    const { props } = this.state;
    const data = props.data || {};
    const remainingPieces = (this.state.expressInwardOutwards?.reduce((acc, item) => {
      return acc + (item.acceptedAt ? item.noOfPieces : 0);
    }, 0) ?? 0) - (this.state.expressPartyOutward?.reduce((acc, item) => {
      return acc + (item.noOfPieces || 0);
    }, 0) ?? 0);
    const editRowId = this.state.editRowData?.id;
    const totalPiecesOther = (this.state.expressInwardOutwards || []).reduce(
      (sum, item) => sum + (item.id !== editRowId ? (item.noOfPieces || 0) : 0),
      0
    );
    const maxAllowedForEdit = Math.max(0, (data?.noOfPieces || 0) - totalPiecesOther);
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("EXPRESS - INWARD")}`}
            />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("View Express (Inward)")}
                        </h4>
                      </div>
                    </div>
                    <Row>
                      <div className="col-xl-8 col-12">
                      <div className="container">
                          {[
                            { label: this.props.t("Jangad Id"), value: data?.jangadId },
                            { label: this.props.t("Party Id"), value: data?.party?.name },
                            { label: this.props.t("Diamond Category"), value: data?.category?.name },
                            { label: this.props.t("Unit Name"), value: data?.factory?.name },
                            { label: this.props.t("Total No of pieces"), value: data?.noOfPieces },
                            { label: this.props.t("Total Weight"), value: formatNumber(data?.totalWeight) },
                            { label: this.props.t("Delivery Boy Name"), value: data?.deliveryBoy?.name || "N/A" },
                            { label: this.props.t("Cycle"), value: data?.cycle },
                            { label: this.props.t("Seles Person Remarks"), value: data?.salesRemark || "N/A" },
                            { label: this.props.t("No Of Pieces Delivered"), value: this.state.totalNoOfPiecesDelivered || "N/A" },
                            { label: this.props.t("Total Cts Delivered"), value: formatNumber(this.state.totalNoOfCtsDelivered) || "N/A" },
                          ].map((item, index) => (
                            <div key={index} className="row align-items-center">
                              <label className="col-md-4 col-form-label">
                                <h5 className="text-secondary fw-bold">{item.label}</h5>
                              </label>
                              <div className="col-md-8">
                                <p className="fs-5 text-dark mb-0">{item.value}</p>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Outward Table */}
                        <div className="row px-3 pt-4">
                          <div>
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t("Data Entry Outward")}
                            </h3>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              data={this.state.expressInwardOutwards.filter((item) => item.isProcessed) || []}
                              columns={columns1}
                              bootstrap4
                              defaultSorted={defaultSorted}
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                               classes="foo"
                            />
                          </div>
                        </div>
                        {/* Returned Table */}
                        <div className="row px-3 pt-4">
                          <div>
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t("Data Entry Returned")}
                            </h3>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              data={this.state.expressInwardOutwards.filter((item) => !item.isProcessed) || []}
                              columns={columns2}
                              bootstrap4
                              defaultSorted={defaultSorted}
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                              classes="foo"
                            />
                          </div>
                        </div>
                        {/* Outward to Party Table */}
                        <div className="row px-3 pt-4">
                          <div>
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t("Outward To Party")}
                            </h3>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              data={this.state.expressPartyOutward || []}
                              columns={columns3}
                              bootstrap4
                              defaultSorted={defaultSorted}
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                              classes="foo"
                            />
                          </div>
                        </div>
                      </div>
                      {/* Action Buttons */}
                      <div className="col-md-12 text-end">
                        <button
                          type="button"
                          className="btn btn-secondary fs-4 px-5"
                          onClick={() => this.props.history.goBack()}
                        >
                          {this.props.t("Back")}
                        </button>
                        {/* "Outward" => only if status is NOT "Pending", "Completed", or "Cancelled" */}
                        {(!["Pending", 'Closed', "Cancelled"].includes(
                          data?.status) && remainingPieces > 0
                        ) && (
                          <button
                            type="button"
                            className="btn btn-primary fs-4 px-5 ms-3"
                            onClick={() => this.setState({ isModalOpen: true })}
                          >
                            {this.props.t("Outward")}
                          </button>
                        )}
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
       
        {/* Outward Modal */}
       <Modal
          isOpen={this.state.isModalOpen}
           toggle={() => this.setState({ isModalOpen: false })}
          centered
        >
          <ModalHeader
             toggle={() => this.setState({ isModalOpen: false })}
          >
            {this.props.t("Outward form")}
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                noOfPieces: "",
                totalWeight: "",
                remark: "",
                deliveryBoyName: "",
              }}
               validationSchema={Yup.object().shape({
                noOfPieces: Yup.number()
                                        .required("Required")
                                        .min(1, "Must be at least 1")
                                        .test(
                                          "max-return-pieces",
                                          `You can only deliver up to ${remainingPieces} pieces.`,
                                          function (value) {
                                            return value <=  remainingPieces;
                                          }
                                        ),
                                      totalWeight: Yup.number().required("Weight is Required"),
                                      deliveryBoyName: Yup.string().required("Delivery Boy is Required"),
                                         })}
              onSubmit={async values => {
                // Always include the correct id and log the payload
                const payload = {
                    inwardId: this.state.props.data?.id, 
                    deliveryBoyName: values.deliveryBoyName,
                    noOfPieces: values.noOfPieces,
                    totalWeight: values.totalWeight,
                    remark: values.remark,
                    isProcessed: true,
                  };
                console.log("Submitting Return & Accept payload:", payload);
                try {
                  const outwardParty =  await addPartyOutwards(payload);
                  if (outwardParty?.success === true) {
                    this.setState({ isModalOpen: false });
                    await this.loadExpressData();
                    if (this.props.refreshList) this.props.refreshList();
                  }
                  else {
                    console.warn(
                      "Outward Party API did not return success:",
                      accept.message
                    );
                  }
                  } catch (err) {
                    console.error("Error submitting outward:", err);
                    // Optionally show error to user
                  }
              }}
            >
              {({ handleSubmit, values, handleChange }) => (
                <Form onSubmit={handleSubmit}>
                    <div className="mb-3 d-flex align-items-center">
                    <Label
                      htmlFor="remainingPieces"
                      style={{ minWidth: 180 }}
                      className="me-3"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Remaining Ready pieces")}
                      </h5>
                    </Label>
                    <Field
                      name="remainingPieces"
                      className="form-control w-50"
                      value={remainingPieces}
                      placeholder="Remaining Ready pieces"
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label
                      htmlFor="totalPieces"
                      style={{ minWidth: 180 }}
                      className="me-3"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Pieces to Deliver")}
                      </h5>
                    </Label>
                    <div className="w-50">
                    <Field
                      type="number"
                      name="noOfPieces"
                      className="form-control"
                      placeholder="Pieces to Deliver"
                      value={values.noOfPieces}
                      onChange={handleChange}
                      // max={remainingPieces}
                      // min={1}
                    />
                    <ErrorMessage
                      name="noOfPieces"
                      component="div"
                      className="text-danger mt-1"
                    />
                    </div>
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label
                      htmlFor="totalWeight"
                      style={{ minWidth: 180 }}
                      className="me-3"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Total Weight")}
                      </h5>
                    </Label>
                    <div className="w-50">
                    <Field
                      type="number"
                      name="totalWeight"
                      className="form-control"
                      placeholder="Total Weight"
                      value={values.totalWeight}
                      onChange={handleChange}
                    />
                     <ErrorMessage
                      name="totalWeight"
                      component="div"
                      className="text-danger mt-1"
                    />
                    </div>
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label
                      htmlFor="remark"
                      style={{ minWidth: 180 }}
                      className="me-3"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Remark")}
                      </h5>
                    </Label>
                    <Field
                      type="text"
                      name="remark"
                      className="form-control w-50"
                      placeholder="Remark"
                      as="textarea"
                      rows="3"
                      value={values.remark}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label
                      htmlFor="deliveryBoyName"
                      style={{ minWidth: 180 }}
                      className="me-3"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Delivery Boy")}
                      </h5>
                    </Label>
                    <div className="w-50">
                    <Field
                      as="select"
                      name="deliveryBoyName"
                      className="form-control"
                      value={values.deliveryBoyName}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        {this.props.t("Select")}
                      </option>
                      {this.state.deliveryBoyList?.map(boy => (
                        <option key={boy.id} value={boy.id}>
                          {boy.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="deliveryBoyName"
                      component="div"
                      className="text-danger mt-1"
                    />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-primary" type="submit">
                      {this.props.t("Submit")}
                    </button>
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={() =>
                        this.setState({ isReturnAndAccept: false })
                      }
                    >
                      {this.props.t("Cancel")}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>

        {/* Edit Outward Modal */}
        <EditOutwardModal
          isOpen={this.state.isEditModalOpen}
          toggle={() => this.setState({ isEditModalOpen: false, editRowData: null })}
          deliveryBoyList={this.state.deliveryBoyList}
          editRowData={this.state.editRowData}
          maxAllowedForEdit={maxAllowedForEdit}
          initialValues={{
            noOfPieces: this.state.editRowData?.noOfPieces || "",
            totalWeight: formatNumber(this.state.editRowData?.totalWeight) || "",
            remark: this.state.editRowData?.remark || "",
            deliveryBoyName: this.state.editRowData?.deliveryBoy?.id || "",
          }}
          t={this.props.t}
          onSubmit={async values => {
            const payload = {
              id: this.state.editRowData?.id,
              inwardId: this.state.editRowData?.inwardId,
              deliveryBoyName: values.deliveryBoyName,
              noOfPieces: values.noOfPieces,
              totalWeight: values.totalWeight,
              remark: values.remark,
            };
            try {
              const editOutward = await updateOutward(payload);
              if (editOutward?.success === true) {
                this.setState({ isEditModalOpen: false, editRowData: null });
                await this.loadExpressData();
                if (this.props.refreshList) this.props.refreshList();
              }
              this.setState({ isEditModalOpen: false, editRowData: null });
            } catch (err) {
              console.error("Error editing outward:", err);
            }
          }}
        />
      </React.Fragment>
    );
  }
}
export default withTranslation()(ExpressViewInward);
